module.exports = __webpack_public_path__ + "img/yamile.95770987.png";